import { render, staticRenderFns } from "./priceSize.vue?vue&type=template&id=5e1d1ae8&scoped=true"
import script from "./priceSize.vue?vue&type=script&lang=js"
export * from "./priceSize.vue?vue&type=script&lang=js"
import style0 from "./priceSize.vue?vue&type=style&index=0&id=5e1d1ae8&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e1d1ae8",
  null
  
)

export default component.exports